import { useMutation } from '@tanstack/react-query';
import { deleteProductFromProductGroup } from './apiDeleteProductFromProductGroup';
import { useDispatch } from 'react-redux';
import { ErrorResponse, globalError } from '../../store/notifications/actions';
import { AxiosResponse } from 'axios';
import { invalidateLibraryManagedProductGroupProducts } from './useLibraryManagedProductGroupProducts';

export const useDeleteProductFromProductGroup = (productGroupId: string) => {
    const dispatch = useDispatch();

    return useMutation<AxiosResponse<void>, ErrorResponse, string>(
        productId =>
            deleteProductFromProductGroup({
                productGroupId,
                productId
            }),
        {
            onSuccess: () => {
                invalidateLibraryManagedProductGroupProducts(productGroupId).then();
            },
            onError: error => {
                dispatch(globalError(error));
            }
        }
    );
};
